const ArrowUp = (props) => {
  const { isHidden } = props;
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`h-4 w-4 transition-transform duration-300 transform ${
      isHidden ? "rotate-180" : "rotate-0"
    }`}
    viewBox="0 0 20 20"
    fill="currentColor"
    >
    <path
      fillRule="evenodd"
      d="M10 3a1 1 0 00-.707.293l-7 7a1 1 0 101.414 1.414L10 5.414l6.293 6.293a1 1 0 001.414-1.414l-7-7A1 1 0 0010 3z"
      clipRule="evenodd"
    />
    </svg>
  )
}

export default ArrowUp